const TeamPrivacyConstants = {
  VISIBLE: "VISIBLE",
  SECRET: "SECRET",
} as const;

export default TeamPrivacyConstants;
